/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

    $(document).ready(function(){

        $('.header-toggle').on('click', '.btn', function(){
            $('.site').toggleClass('open');
        }); // header-toggle
        $('.site-overlay').on('click', function(){
            $('.site').toggleClass('open');
        }); // site-overlay

        $('.form-group-btn').each(function(){
            $(this).css( 'padding-left', $(this).find('.btn').outerWidth() );
        }); // form-group-btn

        /**
         * CONTRAST
         * Toggles contrast on/off
         */
        $('a[href="#contrast"]').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $('body').toggleClass('hc');
            var contrast = '';
            if ($('body').hasClass('hc')) {
                contrast = 'hc';
            }
            $.cookie("contrast", null);
            $.cookie("contrast", contrast, {expires:365, path:'/'});
        });
        // login-modal */

        /**
         * RESPONSIVE VIDEOS
         * Make videos responsive
         */
        $('.entry-content iframe').each(function(){
            $(this).wrap( '<div class="embed-responsive embed-responsive-16by9"></div>' );
        });
        // entry-content iframe */

        /*!
         * POP-UP SHARE
         * Open share options on a pop-up window
         * I know it feels like coding in 1999, but
         * it's what most social buttons do anyway.
         */
        $('.entry-share a.sm-link').on('click', function(e){
            var $h = 510,
                $w = 510,
                px = Math.floor( ((screen.availWidth || 1024) - $w) / 2 ),
                py = Math.floor( ((screen.availHeight || 700) - $h) / 2 );
            var popup = window.open( $(this).attr('href'), 'social',
                'width='+$w+',height='+$h+',left='+px+',top='+py+
                ',location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1');
            if ( popup ) {
                popup.focus();
                e.preventDefault();
            }
            return !!popup;
        });
        // pop-up share */

        /**
         * EXTERNAL LINKS
         * Automatically creates a external link icon
         * on externall links
         */
        $('body').find('a[href*="http"]').each(function(){
            if (this.hostname !== location.hostname && !$(this).hasClass('skip-external')) {
                $(this).attr('rel', 'external');
                $(this).append(' <span class="sr-only">Site externo</span>');
            }
        });
        // external links */

        /**
         * TRACK ANALYTICS
         * track if download click
         */
        function trackAnalytics( eventName, eventTitle, eventDetail ) {
            // Don't allow if parameters are not passed
            if ( eventName === undefined || eventTitle === undefined || eventDetail === undefined) {
                return false;
            }
            if ( typeof ga !== undefined ) {
                ga( 'send', 'event', eventName, eventTitle, eventDetail );
                console.log('Event sent trought "ga"');
                return true;
            }
            if ( typeof _gaq !== undefined ) {
                _gaq.push(['_trackEvent', eventName, eventTitle, eventDetail]);
                console.log('Event sent trought "_gaq"');
                return true;
            }
            if ( typeof __gaTracker !== undefined ) {
                __gaTracker('send', 'event', eventName, eventTitle, eventDetail);
                console.log('Event sent trought "__gaTracker"');
                return true;
            }
            console.log('Event not tracked!');
            return false;
        } // track analytics  */

        // Track external links
        $('body').find('a[href*="http"]').click(function(e){
            if (this.hostname !== location.hostname) {
                e.preventDefault();
                // Define variables
                var eventName   = 'External site',
                    eventTitle  = document.title, 
                    eventDetail = $(this).attr('href');
                // Track downloads
                trackAnalytics( eventName, eventTitle, eventDetail );
                // Set redirect timeout (emulates normal behavior)
                setTimeout( function(){
                    window.location.href = eventDetail;
                }, 500);
            }
        });

        // Track file downloads
        // $('body').find("a[href$='.doc'], a[href$='.docx'], a[href$='.gzip'], a[href$='.pdf'], a[href$='.rar'], a[href$='.tar.gz'], a[href$='.tar'], a[href$='.xls'], a[href$='.xlsx'], a[href$='.zip'],")
        // .click( function(e){
        //     e.preventDefault();
        //     // Define variables
        //     var eventName   = 'Download',
        //         eventTitle  = document.title, 
        //         eventDetail = $(this).attr('href');
        //     // Track downloads
        //     trackAnalytics( eventName, eventTitle, eventDetail );
        //     // Set redirect timeout (emulates normal behavior)
        //     setTimeout( function(){
        //         window.location.href = eventDetail;
        //     }, 500);
        // });
        

    }); // document.ready

    /**
     * jQuery Cookie plugin
     *
     * Copyright (c) 2010 Klaus Hartl (stilbuero.de)
     * Dual licensed under the MIT and GPL licenses:
     * http://www.opensource.org/licenses/mit-license.php
     * http://www.gnu.org/licenses/gpl.html
     *
     */
    jQuery.cookie=function(e,n,o){if(arguments.length>1&&"[object Object]"!==String(n)){if(o=jQuery.extend({},o),(null===n||void 0===n)&&(o.expires=-1),"number"===typeof o.expires){var t=o.expires,r=o.expires=new Date();r.setDate(r.getDate()+t);}return n=String(n),document.cookie=[encodeURIComponent(e),"=",o.raw?n:encodeURIComponent(n),o.expires?"; expires="+o.expires.toUTCString():"",o.path?"; path="+o.path:"",o.domain?"; domain="+o.domain:"",o.secure?"; secure":""].join("");}o=n||{};var i,c=o.raw?function(e){return e;}:decodeURIComponent;return(i=new RegExp("(?:^|; )"+encodeURIComponent(e)+"=([^;]*)").exec(document.cookie))?c(i[1]):null;};

})(jQuery); // Fully reference jQuery after this point.
